import React, { useCallback, useEffect, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
  SUSPENDED, ShowError, DROPDOWN_LIST_NONE,
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
  JSON_KEY_SUBMITTER, JSON_KEY_STATUS,
  ITEM_STATUS, ITEM_CREATE, ITEM_MODIFY, EVENT_TYPE_MARKET_STATUS, StatusSimpleOptions,
  EVENT_TYPE_MARKET_MODIFY, EVENT_TYPE_MARKET_CREATE, JSON_KEY_DESCRIPTION, NO,
  JSON_KEY_WITHDRAW_ALL_ORDERS,
  JSON_KEY_MARKET,
  ConvertStatusFromNameToId,
  SUSPEND,
  ConvertStatus,
  JSON_KEY_EXCHANGE,
  STATUS_ACTIVE,
  EVENT_TYPE_MARKET_CANCEL_ALL_ORDERS,
  ITEM_CANCEL_ALL_ORDERS,
  ConfirmConfirmCancelAndSubmit,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSGTYPE_MARKET_CANCEL_ALL_ORDERS, MSGTYPE_MARKET_CHANGE_STATUS, MSGTYPE_MARKET_CREATE, MSGTYPE_MARKET_MODIFY, } from "../../common/msg_types";
import { RenderDropdown, InputField } from "../../common/utilies";
import { yesNoOptions } from "../../common/convert_functions";

const MarketsAdminForm = ({ rowData, onClose, marketOptions, exchangeOptions }) => {
   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // tab1
   const [code, setCode] = useState(rowData?.code);
   const [status, setStatus] = useState(SUSPEND);

   // tab 2 & 3
   const [exchange, setExchange] = useState(DROPDOWN_LIST_NONE);
   const [description, setDescription] = useState(rowData?.descr);
   const [withdrawAllOrders, setWithdrawAllOrders] = useState(NO);

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onMarketDropDownChange = useCallback((e) => setCode(e.target.value), [setCode]);
   const onStatusDropDownChange = useCallback((e) => setStatus(e.target.value), [setStatus]);
   const onExchangeDropDownChange = useCallback((e) => setExchange(e.target.value), [setExchange]);
   const onYesNoDropDownChange = useCallback((e) => {setWithdrawAllOrders(e.target.value)}, [setWithdrawAllOrders]);
   

   const onMarketModifyDropDownChange = (e) => {
      setCode(e.target.value);
      setDescription('');
      setExchange(DROPDOWN_LIST_NONE);
      setStatus(SUSPENDED);
   };

   // const ConfirmAndSubmit = async ({ title, text, item }) => {
   //    const confirmed = await confirmationDialog({ title, text });
   //    if (confirmed) handleStatusConfirmationSubmit(item);
   // };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const base = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_MARKET]: code,
      };

      switch (submitItem) {
         case ITEM_STATUS:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_MARKET_STATUS,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_MARKET_CHANGE_STATUS,
                  [JSON_KEY_STATUS]: status,
                  [JSON_KEY_WITHDRAW_ALL_ORDERS]: withdrawAllOrders,
               }
            );
            break;

         case ITEM_CANCEL_ALL_ORDERS:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_MARKET_CANCEL_ALL_ORDERS,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_MARKET_CANCEL_ALL_ORDERS,                  
               }
            );
            break;
            
         case ITEM_CREATE:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_MARKET_CREATE,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_MARKET_CREATE,
                  [JSON_KEY_DESCRIPTION]: description,
                  [JSON_KEY_EXCHANGE]: exchange,
                  [JSON_KEY_STATUS]: status,
               }
            );
            break;

         case ITEM_MODIFY:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_MARKET_MODIFY,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_MARKET_MODIFY,
                  [JSON_KEY_DESCRIPTION]: description,
                  [JSON_KEY_EXCHANGE]: exchange,
                  [JSON_KEY_STATUS]: status,
                  [JSON_KEY_WITHDRAW_ALL_ORDERS]: withdrawAllOrders, 
               }
            );
            break;

         default:
            console.log("MarketsAdminForm unknown submit item");
      }
   };


   const ValidateFields = () => {
      if (!code) return "Code is missing";
      if (code === DROPDOWN_LIST_NONE) return "Code is missing";
      if (!description) return "Description is missing";
      if (!exchange || (exchange === DROPDOWN_LIST_NONE)) return "Exchange is missing";
      if (!status) return "Status is missing";
      return null;
   };

   const handleStatusSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Market Status Change",
         text: `Setting market ${code} to ${ConvertStatus(status)}`,
         item: ITEM_STATUS,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };


   const handleCancelAllOrdersSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);
      if (withdrawAllOrders === NO) return ShowError("Cancel All Orders must be YES");
      

      ConfirmConfirmCancelAndSubmit({
         title: "Market Cancel All Orders",
         text: `Do you want to cancel all orders on the Market ${code}`,
         item: ITEM_CANCEL_ALL_ORDERS,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      // ConfirmAndSubmit({
      //    title: "Market Cancel All Orders",
      //    text: `Do you want to cancel all orders on the Market ${code}`,
      //    item: ITEM_CANCEL_ALL_ORDERS,
      // });
      onClose(); // your modal close function
   };
   
   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Create Market",
         text: `Creating new market: ${code}`,
         item: ITEM_CREATE,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      // ConfirmAndSubmit({
      //    title: "Create Market",
      //    text: `Creating new market: ${code}`,
      //    item: ITEM_CREATE,
      // });
      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Modify Market",
         text: `Modifying market: ${code}`,
         item: ITEM_MODIFY,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      // ConfirmAndSubmit({
      //    title: "Modify Market",
      //    text: `Modifying market: ${code}`,
      //    item: ITEM_MODIFY,
      // });
      onClose(); // your modal close function
   };

   useEffect(() => {
      if (!rowData) return;
         setCode(rowData.code || '');
         setDescription(rowData.descr || '');
         setExchange(rowData.exch || DROPDOWN_LIST_NONE);
         setStatus(rowData?.status ? ConvertStatusFromNameToId(rowData.status) : SUSPEND);
   }, [rowData]);

   useEffect(() => {
      if (selectedTabIndex === 2) {
         setStatus(SUSPENDED);
      }
   }, [selectedTabIndex]);

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Market Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Change Status</Tab>
               <Tab>Modify Market</Tab>
               <Tab>Create Market</Tab>
               <Tab>Cancel All Orders</Tab>
            </TabList>

            {/* Tab 1: Change Status */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleStatusSubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, marketOptions, onMarketDropDownChange)}
               </div>
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>
               <div className="top">
               {RenderDropdown(
                  "Cancel All Orders",
                  status === STATUS_ACTIVE ? NO : withdrawAllOrders, // force NO if Active
                  yesNoOptions,
                  status === STATUS_ACTIVE ? () => {} : onYesNoDropDownChange, // ignore changes if Active
                  status === STATUS_ACTIVE // disable dropdown if Active
               )}
               </div>
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 2: Modify Market */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, marketOptions, onMarketModifyDropDownChange)}
               </div>

               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Exchange", exchange, exchangeOptions, onExchangeDropDownChange)}
               </div>

               {/*}
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Withdraw All Orders", withdrawAllOrders, yesNoOptions, onYesNoDropDownChange)}
               </div>               
               */}

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
            
            {/* Tab 3: Create Market */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
               <div>
                  <InputField label="Code" value={code} onChange={setCode} />
               </div>

               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Exchange", exchange, exchangeOptions, onExchangeDropDownChange)}
               </div>

               {/*}
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange, true)}
               </div>
               */}
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>


            {/* Tab 4: Cancel All Orders */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCancelAllOrdersSubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, marketOptions, onMarketDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Withdraw All Orders", withdrawAllOrders, yesNoOptions, onYesNoDropDownChange)}
               </div>               

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

         </Tabs>
         </div>
      </div>
   );
};

export default MarketsAdminForm;
